import React from "react";
import Footer from "../../Components/Footer";
import Header from "../../Components/Header";
import "../../assets/css/privacy.css";

const Terms = () => {
	return (
		<>
			<Header />
			{/* Page Header starts here */}
			<section className="page-header">
				<div className="container">
					<div className="row">
						<div className="col-lg-12">
							<h2>Terms and Conditions</h2>
							<span>Home {">"} Terms & Condition</span>
						</div>
					</div>
				</div>
			</section>
			{/* Page Header ends here */}
			{/* Privacy starts here */}
			<section className="privacy-sec">
				<div className="container">
					<div className="row">
						<div className="col-lg-12">
							<div className="content-wrapper">
								<div className="row">
									<div className="col-lg-8">
										<div className="heading-wrapper">
											<h3>Terms and Conditions</h3>
										</div>
									</div>
								</div>
								<div className="privacy-content-wrapper">
									<h4>Disclaimer</h4>
									<h4>LEGAL TERMS FOR (website here)</h4>
									<h4>Pater Up North LLC; Studio Pro DBA</h4>
									<br />
									<h4>I. General</h4>
									<p>
										Your access to and use of this site is subject to the
										following Legal Terms. Please read these Legal Terms
										carefully before accessing or using the site, so that you
										fully understand your rights and responsibilities. BY
										ACCESSING OR USING THE SITE, YOU SIGNIFY YOUR AGREEMENT WITH
										THESE LEGAL TERMS.
										<br />
										PATER UP NORTH LLC via STUDIO PRO RESERVES THE RIGHT TO
										CHANGE THESE LEGAL TERMS AT ANY TIME. IF WE DECIDE TO CHANGE
										THE LEGAL TERMS, WE WILL POST ANY CHANGES ON THIS WEB SITE.
										ANY SUCH CHANGES SHALL BE EFFECTIVE UPON POSTING ON THE WEB
										SITE. BY ACCESSING THE SITE FOLLOWING THE POSTING OF CHANGES
										TO THE LEGAL TERMS, YOU AGREE TO ALL SUCH CHANGES.
										<br />
										These Legal Terms are agreed to by and between you and
										STUDIO PRO (PATER UP NORTH LLC). In consideration of your
										use of and access to this web site, and the promises and
										obligations in these Legal Terms, and intending to be
										legally bound, you and STUDIO PRO (PATER UP NORTH LLC) here
										by agree to all of the terms and conditions of these Legal
										Terms. These Legal Terms describe the terms and conditions
										under which STUDIO PRO (PATER UP NORTH LLC) welcomes you to
										this site. Please read the Legal Terms carefully so that you
										fully understand your rights and responsibilities.
									</p>
								</div>
								<div className="privacy-content-wrapper">
									<h4>
										II. STUDIO PRO (PATER UP NORTH LLC) Intellectual Property
										Rights
									</h4>
									<p>
										Copyright 2022 STUDIO PRO (PATER UP NORTH LLC). All rights
										reserved.
										<br />
										All copyrightable text, audio, video, graphics, charts,
										photographs and icons, design, selection, and arrangement of
										content in any medium on this site is copyrighted by STUDIO
										PRO (PATER UP NORTH LLC), unless otherwise noted. The
										distinctive and original layout and presentation of this
										site also constitutes protectable trade dress under
										applicable federal law. In addition, many registered and
										unregistered marks may appear throughout this site and they
										are the sole property of STUDIO PRO (PATER UP NORTH LLC).
										This site may also contain references to third-party marks,
										which are the property of their respective owners. If you
										have any questions regarding a specific mark or any other
										STUDIO PRO (PATER UP NORTH LLC) intellectual property,
										please contact STUDIO PRO (PATER UP NORTH LLC).Any
										unauthorized use of any of STUDIO PRO (PATER UP NORTH LLC)
										marks, or of its copyrighted material or trade dress or any
										other intellectual property, is strictly prohibited, and
										will be prosecuted to the fullest extent that the law
										provides.
									</p>
								</div>
								<div className="privacy-content-wrapper">
									<h4>III. Use of This Site</h4>
									<p>
										Permission is granted to download this site’s content and to
										print a single hard copy for the user’s use only. You may
										not otherwise use,copy, modify, distribute, republish or
										transmit any of the content or materials of this site
										without the written permission of STUDIO PRO (PATER UP NORTH
										LLC).
										<br />
										You understand and expressly agree that use of this site is
										at your own risk, that any material or data downloaded or
										otherwise obtained through the use of the site or by virtue
										of interaction with other users is at your own discretion
										and risk, and that you are solely responsible for any damage
										to your computer system or loss of data that results from
										the download of such material or data, and for any other
										form of damage that may be incurred. STUDIO PRO (PATER UP
										NORTH LLC) SHALL NOT BE LIABLE TO USERS FOR ANY DAMAGE
										RESULTING FROM USE OF THE SITE, NOR IS STUDIO PRO (PATER UP
										NORTH LLC) IN ANY WAY RESPONSIBLE FOR THE CONDUCT OF USERS,
										OR INFORMATION EXCHANGED ON THE SITE.
										<br />
										Although STUDIO PRO (PATER UP NORTH LLC) endeavors to
										provide accurate information, this site is intended to be
										for general reference purposes only. STUDIO PRO (PATER UP
										NORTH LLC) makes no guarantees with respect to any
										information provided on the site.
									</p>
								</div>
								<div className="privacy-content-wrapper">
									<h4>IV. No Warranty</h4>
									<p>
										USER EXPRESSLY UNDERSTANDS AND AGREES THAT STUDIO PRO (PATER
										UP NORTH LLC) SHALL NOT BE LIABLE FOR ANY LOSS OR DAMAGE
										(DIRECT, INDIRECT, PUNITIVE, ACTUAL, CONSEQUENTIAL,
										INCIDENTAL, SPECIAL, OR OTHERWISE) RESULTING FROM ANY USE
										OF, OR INABILITY TO USE, THIS WEBSITE, OR RESULTING FROM ANY
										ERRORS OR OMISSIONS IN THE CONTENT OF THIS WEBSITE,
										REGARDLESS OF THE BASIS UPON WHICH LIABILITY IS CLAIMED,
										EVEN IF STUDIO PRO (PATER UP NORTH LLC) HAS BEEN ADVISED OF
										THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
										<br />
										THIS LIMITATION IS SUBJECT TO THE PROVISIONS OF ANY
										APPLICABLE LAW THAT MAY RESTRICT ITS SCOPE.
									</p>
								</div>
								<div className="privacy-content-wrapper">
									<h4>V. No Liability</h4>
									<p>
										In no event shall STUDIO PRO (PATER UP NORTH LLC) or any of
										its affiliates, officers, directors, employees, consultants
										or agents be liable for any direct, indirect, punitive,
										special, incidental, or consequential damages or any damages
										whatsoever, including, without limitation, damages for loss
										of use, data, information, profits or business interruption,
										arising out of or in any way related to the use or
										performance of this web site or any linked site, to any
										information or products or anything else obtained through
										this site, or otherwise arising out of the use of this site,
										or to the inability to use the site, whether based in tort,
										contract, negligence, strict liability or otherwise, even if
										STUDIO PRO (PATER UP NORTH LLC) has been advised of the
										possibility of damages. Your sole and exclusive remedy is to
										discontinue using this web site.
									</p>
								</div>
								<div className="privacy-content-wrapper">
									<h4>VI. STUDIO PRO (PATER UP NORTH LLC) Indemnified</h4>
									<p>
										You agree to indemnify, defend and hold harmless STUDIO PRO
										(PATER UP NORTH LLC), its affiliates, officers, directors,
										employees, consultants and agents from any and all losses,
										expenses, third-party claims, liability, damages and costs
										(including, but not limited to, attorneys’ fees) arising
										from your use of the site or the violation of these Legal
										Terms, including without limitation, your infringement, or
										infringement by any other users of your account, of any
										intellectual property or other right or policy of any person
										or STUDIO PRO (PATER UP NORTH LLC) .
									</p>
								</div>
								<div className="privacy-content-wrapper">
									<h4>VII. Privacy Policy</h4>
									<p>
										Please carefully review the Privacy Policy for this site,
										listed below. By your access or use of this site, you here
										by agree to the terms of this Privacy Policy, which are
										incorporated into these Legal Terms by reference.
									</p>
								</div>
								<div className="privacy-content-wrapper">
									<h4>VIII. Advertisements and Other Sites</h4>
									<p>
										STUDIO PRO (PATER UP NORTH LLC) Web site may contain links
										to third party websites that are not under the control of
										STUDIO PRO (PATER UP NORTH LLC). STUDIO PRO (PATER UP NORTH
										LLC) makes no representations whatsoever about any other web
										site to which User may have access through the STUDIO PRO
										(PATER UP NORTH LLC) web site. When User accesses a
										third-party web site, User does so at its own risk and
										acknowledges that STUDIO PRO (PATER UP NORTH LLC) is not
										responsible or liable for any content, advertising, products
										or other materials available from such third-party sites.
										<br />
										User also agrees that STUDIO PRO (PATER UP NORTH LLC) shall
										not be liable for any loss or damage of any sort incurred as
										the result of using any third party’s web site. Mention of
										third-party companies and web sites on STUDIO PRO (PATER UP
										NORTH LLC) Web site is for informational purposes only and
										does not constitute an endorsement or recommendation.
									</p>
								</div>
								<div className="privacy-content-wrapper">
									<h4>IX. Agreement to Legal Terms; Changes</h4>
									<p>
										BY YOUR ACCESS OR USE OF THIS SITE, YOU HERE BY AGREE TO
										THESE LEGAL TERMS. These Legal Terms constitute the entire
										agreement between the parties with respect to the subject
										matter contained in the Legal Terms and supersede and
										replace all prior or contemporaneous understandings or
										agreements, written or oral, regarding such subject matter.
										Any waiver of any provision of these Legal Terms will be
										effective only if in writing and signed by STUDIO PRO (PATER
										UP NORTH LLC) These Legal Terms will inure to the benefit of
										STUDIO PRO (PATER UP NORTH LLC)’s successors, assigns and
										licensees.
									</p>
								</div>
								<div className="privacy-content-wrapper">
									<h4>X. Interpretation and Disputes</h4>
									<p>
										These Legal Terms are governed by the laws of the United
										States and the State of Michigan, without regard to any
										conflict of law’s provisions. All disputes under this
										Agreement that cannot be resolved by the parties shall be
										submitted to arbitration in Grand Traverse County, Michigan
										under the rules and regulations of the American Arbitration
										Association. Either party may invoke this paragraph after
										providing 30 days written notice to the other party.
										<br />
										The dispute(s) arising under this Agreement shall be decided
										by a panel of three arbitrators with each party hereto
										selecting one arbitrator and the two selected arbitrators to
										choose the third arbitrator. An arbitrator sitting in any
										arbitration arising hereunder shall not have the authority
										or power to modify or alter any express condition or
										provision of this Agreement or to render any award which by
										its terms has the effect of altering or modifying any
										express condition or provisions hereof. All costs of
										arbitration shall be divided equally between the parties.
										Any award may be enforced by a court of law. User agrees
										that, regardless of any statute or law to the contrary, any
										dispute arising out of or relating to this Agreement must be
										filed within one (1) year after such claim or cause of
										action arises or will be forever barred .
									</p>
								</div>
								<div className="privacy-content-wrapper">
									<h4>XI. Contacting Us</h4>
									<p>
										If you have any other questions or concerns regarding these
										Legal Terms, please contact us via e-mail.
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* Privacy ends here */}
			<Footer />
		</>
	);
};

export default Terms;
